import { NextApiRequest, NextApiResponse } from 'next';
import { getSession } from '../../services/session.service';
import {set} from "lodash";
import UtmService from '../../services/UtmService';

const PARTNER_MONGO_URI = process.env.PARTNER_MONGO_URI || "";

export default async function handler(
  req: NextApiRequest,
  res: NextApiResponse,
): Promise<void> {
  const { utms, utmsFromUrl, locale } = req.body;
  try {
    const session = await getSession(req, res);
    const utmService = UtmService(PARTNER_MONGO_URI);
    const partnerData = await utmService.getPartner(utmsFromUrl, []);

    set(session, 'utms', utms); // It's for apps that only using frontendV2
    set(session, 'utm', utms); // It's for apps that using frontendV1 and frontendV2
    set(session, 'utmsFromUrl', utmsFromUrl);
    set(session, 'locale', locale);
    set(session, 'partner', partnerData.session);

    await session.commit();

    res.setHeader('Content-Type', 'application/json');
    res.status(200).send({ success: true, error: '' });
  } catch (err) {
    console.log('failed to save', err);
    res.setHeader('Content-Type', 'application/json');
    res
      .status(500)
      .send({ success: false, error: 'Failed to update session:' + err });
  }
}
